// extracted by css-extract-rspack-plugin
export default {"Description":"MetadataInfo-module__Description___WNaOE","EmptyDescription":"MetadataInfo-module__EmptyDescription___HnAhH"};